import Tag, { Props as TagProps } from '../../Atoms/Tag';
import Icon from '../../Atoms/Icon';

export interface Props
  extends React.HTMLAttributes<HTMLDivElement> {
  title: string;
  tags: TagProps[];
  onClick?: () => void;
}

function CardVacancy({ title, tags, onClick }: Props) {
  return (
    <div
      className="group flex w-full cursor-pointer items-stretch overflow-hidden rounded-xl shadow-light"
      role="button"
      tabIndex={0}
      onClick={onClick}
      onTouchEnd={onClick}
      onKeyDown={(event) => {
        if (event.key === 'Enter') {
          onClick?.();
        }
      }}
    >
      <div className="relative flex min-h-[200px] w-full flex-col justify-between gap-7 overflow-hidden rounded-xl bg-gradient-to-l from-sl-blue via-white to-white bg-[length:200%] bg-left p-7 text-sl-blue duration-300 group-hover:via-sl-blue-dark group-hover:bg-right group-hover:text-white md:min-h-[280px] md:rounded-l-none lg:min-h-[320px]">
        <span className="text-lg md:text-xl lg:text-2xl">
          {title}
        </span>

        {tags && (
          <div className="flex flex-col gap-3 text-sl-blue group-hover:text-white">
            {tags?.map((tag) => (
              <Tag
                key={tags.indexOf(tag)}
                {...tag}
                iconClass="group-hover:text-sl-yellow"
              />
            ))}
          </div>
        )}

        <div
          style={{
            background:
              'linear-gradient(225deg, #23275B 0%, #494F94 100%)'
          }}
          className="absolute right-0 bottom-0 flex h-[48px] w-[48px] items-center justify-center rounded-tl-[100%] bg-gradient-to-l from-sl-blue to-sl-blue-dark pt-2 pl-2 text-center text-sm text-white duration-300 md:h-[90px] md:w-[90px] md:pl-4 md:pt-4 md:text-lg"
        >
          <Icon icon="arrow-right" />
        </div>
      </div>
    </div>
  );
}

export default CardVacancy;
